import { BillingDetails } from './../../data/web-api-client';
import '@/types';
import notificationService from '@/services/notificationService';
import contactsService from '@/services/contactsRepository';

export default class Contact implements IContact {
    public team?: string | undefined;
    public companyId?: string | undefined;
    public pricingAgreements: IPricingAgreement[] | null = [];
    public id?: string;
    public type: string = 'Contact';
    public logs: ILog[] = [];
    public firstname: string = '';
    public middlename?: string;
    public lastname?: string;
    public jobTitle?: string;
    public email?: string;
    public phone?: string;
    public mobile?: string;
    public language?: string;
    public nationality?: string;
    public nationalInsuranceNumber?: string;
    public socialSecurityNumber?: string;
    public dateOfBirth?: string;
    public tags: string[] = [];
    public notes?: string;
    public readonly displayName: string = '';
    public address: IAddress = {
        addressline1: '',
        addressline2: '',
        zip: '',
        city: '',
        country: '',
        type: 0,
        name: 'default',
    };
    public userId?: string;
    public BillingDetails?: BillingDetails;

    public loading: boolean = false;
    public saving: boolean = false;

    public async loadData(id: string) {
        try {
            this.loading = true;
            const result = await contactsService.getSingle(id);
            Object.assign(this, result.data);
        } catch {
            notificationService.failedToLoad();
        } finally {
            this.loading = false;
        }
    }

    public async save(relationId?: string) {
        let saved = false;
        try {
            this.saving = true;
            if (this.id) {
                const result = await contactsService.update(this);
                Object.assign(this, result.data);
            } else {
                const result = await contactsService.create(this, relationId);
                Object.assign(this, result.data);
            }
            saved = true;
            notificationService.saved();
        } catch {
            notificationService.failedToLoad();
        } finally {
            this.saving = false;
        }

        return saved;
    }
}
